import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEsponente = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1000px",
	height: "1000px",
	viewBox: "0 0 1000 1000",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Group 7" }), /* @__PURE__ */ _jsx("g", {
		id: "10.-Checker",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group-7",
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "icon_Background",
				x: 0,
				y: 0,
				width: 1e3,
				height: 1e3
			}), /* @__PURE__ */ _jsxs("g", {
				id: "esponente",
				transform: "translate(277.777778, 277.777778)",
				strokeWidth: 28,
				children: [/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle-Copy-2",
					stroke: "#0056C1",
					x: 14,
					y: 147.333333,
					width: 194.222222,
					height: 305.333333
				}), /* @__PURE__ */ _jsx("rect", {
					id: "Rectangle-Copy-6",
					stroke: "#1973E1",
					x: 291.777778,
					y: 14,
					width: 138.666667,
					height: 166.444444
				})]
			})]
		})
	})]
});
export default SvgEsponente;
